import React, { useContext } from 'react';
import PortletContext from '../PortletContext';
import PortletSearch from '../Search';
import PortletBulkActions from '../BulkActions';

function PortletBody({ children }) {
  const {
    config: {
      shouldShowBulkActions,
      renderSearchbar,
    },
  } = useContext(PortletContext);
  return (
    <div className="kt-portlet__body">
      {renderSearchbar
        && <PortletSearch />}
      { shouldShowBulkActions && (
        <PortletBulkActions />
      ) }
      <div className="kt_datatable" id="local_data">
        {children}
      </div>
    </div>
  );
}

export default PortletBody;
